(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["ai-product-slide"] && !window.DesignMode) return;
  try {
    
$('.tab-links a').on('click', function(e) {
  var currentAttrValue = $(this).attr('href');
  
  // Show/Hide Tabs
  $('.tabs ' + currentAttrValue).show().siblings().hide();
  
  // Change/remove current tab to active
  $(this).parent('li').addClass('active').siblings().removeClass('active');

  // Reinitialize the carousel for the newly active tab
  $(currentAttrValue + ' .product-carousel').slick('setPosition').slick('refresh');
  
  e.preventDefault();
});

$(document).ready(function() {
  // Activate the first tab
  $('.tab-links a:first').trigger('click');

  $('.product-carousel').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const stars = document.querySelectorAll('.star');
  const message = document.querySelector('.rating-message');

  stars.forEach(star => {
    star.addEventListener('click', function() {
      const rating = this.getAttribute('data-rating');
      // Here you can send the rating to your server using AJAX or perform any other action
      // For now, let's just display a message
      message.textContent = `You rated this ${rating} stars!`;
    });
  });


  
    var tabLinks = document.querySelectorAll('.tab-link');

    tabLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            console.log('Clicked tab link:', link.href);
        });
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    var button = $('.laberSlidershow .wrapper_caption').find('.buttons');
    if ( button ){
      button.parents('.wrap_text').addClass('has-button');
    }
  });

  } catch(e) { console.error(e); }
})();
      })();
